import axios from "axios";

export const addProfessionalTournament = async (data, token) => {
  try {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("yt_link", data.ytLink);
    formData.append("category", data.type);

    // Goal Videos
    if (data?.video && Array.isArray(data.video)) {
      data.video.forEach((video) => {
        formData.append("video", video);
      });
    }

    // Goal Images  <-- ADD THIS
    if (data?.goalVideos && Array.isArray(data.goalVideos)) {
      data.goalVideos.forEach((goal) => {
        if (goal.goal_image) {
          formData.append("goalImages", goal.goal_image);
        }
      });
    }

    // Send metadata WITHOUT file objects
    formData.append(
      "video_meta",
      JSON.stringify(
        data.video_meta.map((item) => ({
          club_name: item.club_name,
          goal_scorer: item.goal_scorer,
        }))
      )
    );

    if (data?.image) {
      formData.append("image", data.image);
    }

    if (data?.YTVideo) {
      formData.append("ytVideo", data.YTVideo);
    }

    // DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/createProfessionalTournament`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }

    throw new Error(error.message);
  }
};